/**
 *Area utility class to keep track of chat frame position
 *@constructor
 */

export default class Area {
    x: number;

    y: number;

    width: number;

    height: number;

    r: number;

    b: number;

    constructor(x?: number, y?: number, width?: number, height?: number) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }

    setBRPosition(right: number, bottom: number, width: number, height: number) {
        this.r = right;
        this.b = bottom;
        this.width = width;
        this.height = height;
    }

    isXYAxisPos() {
        return this.x >= 0 && this.y >= 0;
    }

    setBottom(bottom: number) {
        this.b = bottom;
    }

    getBottom():number {
        return this.b;
    }

    toJSON() {
        return {
            x: this.x,
            y: this.y,
            r: this.r,
            b: this.b,
            width: this.width,
            height: this.height,
        };
    }
}
